var void0 = function(){};
var lang = document.documentElement.lang;
var winW = 0;
var winH = 0;
var modeResp = false;
var modeMobile = false;
var PAGE_HASH = window.location.hash;

var SEP = "~!~";
var SEP2 = "_!_";


function checkWindow() {
    winW = window.innerWidth;
    winH = window.innerHeight;
    modeResp = winW <= 800;
    
    var userAgent = navigator.userAgent;
    modeMobile = !!(userAgent.indexOf('Android') > -1 || userAgent.match(/(iPad|iPhone|iPod)/i));
}
function writeResolution() {
    var el = document.querySelector(".resolution");
    if (el) el.innerHTML = winW + " x " + winH;
}
function preload() {
    var el = document.getElementById("preloader");
    if (el) {
        setTimeout(function() {
            addClass(el, "loaded");
        }, 600);
    }
}
function reloadPage() {
    window.location.reload();
}

function updateSVar(key, value, callback, blackout) {
    ajax("/action/sessionVariables?key=" + key +
             ((value) ? "&value=" + encodeURIComponent(value) : ""), 
             ((callback) ? callback : function(){}), !blackout);
}
function updateMultiSVars(o, f) {
    var c = 0, l = 0, timeout = 120, k;
    for (k in o) {
        updateSVar(k, o[k], function(){c++;});
        l++;
    }
    var chk = function chk() {
        timeout -= 0.05;
        if (c < l) {
            if (timeout > 0) setTimeout(chk, 50);
        } else {
            if (f) f();
        }
    }();
}

function parseDecimal(str) {
    return parseFloat(str.replace(",", "."));
}

function getQuery(param, search) {
    var se = search !== undefined ? search : window.location.search;
    var qs = se.replace("?", "");
    if (!param || param === "") return qs;
    if (qs === "") return null;

    var qa = qs.split("&");
    for (var i = 0; i < qa.length; i++) {
        var q = qa[i];
        if (q.indexOf("=") > -1) {
            var a = q.split("=");
            if (a[0] === param) return a[1];
        } else {
            if (q === param) return "";
        }
    }
}
function setQuery(param, value, search) {
    var se = search !== undefined ? search : window.location.search;
    var v = encodeURIComponent(value);
    if (se !== "") {
        var qa = se.replace("?", "").split("&");
        var qa2 = [];
        var isNew = true;

        for (var i = 0; i < qa.length; i++) {
            var qi = qa[i];
            var j = qi.indexOf("=");
            var qname = j > -1 ? qi.substring(0, j) : qi;
            if (qname === param) {
                if (v && v !== "") {
                    qi = param + "=" + v;
                } else {
                    qi = param;
                }
                isNew = false;
            }
            qa2.push(qi);
        }
        if (isNew) qa2.push(param + "=" + v);

        return qa2.join("&");
    } else if (v && v !== "") {
        return param + "=" + v;
    } else {
        return param;
    }
}
function removeQuery(param, search) {
    var se = search !== undefined ? search : window.location.search;
    if (!param || param === "") return se.replace("?", "");

    var qa = se.replace("?", "").split("&");
    var qa2 = [];
    for (var i = 0; i < qa.length; i++) {
        var qi = qa[i];
        var j = qi.indexOf("=");
        var qname = j > -1 ? qi.substring(0, j) : qi;

        if (qname !== param) qa2.push(qi);
    }

    return qa2.join("&");
}

function setHoverBar() {
    var navs = document.getElementsByClassName("nav-btn"),
        bar = document.querySelector(".head-menu .hoverbar");
    
    var fn = {
        enter: function() {
            var pos = {x: this.offsetLeft, y: this.offsetTop},
                dim = {w: this.clientWidth, h: this.clientHeight},
                p = "getComputedStyle" in window ? dim.h - parseFloat(window.getComputedStyle(this, null).getPropertyValue("height")) : dim.h - parseFloat(this.currentStyle.height);
            
            bar.style.top = (pos.y + p/2) + "px";
            //bar.style.height = (dim.h - p) + "px";
            addClass(bar, "active");
        },
        out: function() {
            removeClass(bar, "active");
        }
    };
    
    for (var i = 0; i < navs.length; i++) {
        var nav = navs[i];
        nav.addEventListener("mouseenter", fn.enter);
        nav.addEventListener("mouseout", fn.out);
    }
}
function toggleMenu() {
    var btn = this,
        el = document.getElementById("main_menu"),
        on = "open";

    if(searchWord(el.className, on) === -1) {
        addClass(btn, on);
        addClass(el, on);
    } else {
        removeClass(btn, on);
        removeClass(el, on);
    }
}

function toggleAccordion(e) {
    var targ = this.hasAttribute("data-qs") ? qs(this.getAttribute("data-qs")) : 
            getAncestor(this, "accordion-header").nextElementSibling;
    var aCls = "active";
    
    if (hasClass(targ, aCls)) {
        $(targ).slideUp().removeClass(aCls);
    } else {
        $(targ).slideDown().addClass(aCls);
    }
    if (hasClass(this, aCls)) {
        removeClass(this, aCls);
    } else {
        addClass(this, aCls);
    }
}

function loginCheckUp(){
    var form = document.getElementById("signinForm"),
        user = qs(".js-un", form).value,
        inp = qs(".js-ff", form);
    
    inp.value = inp.getAttribute("data-page") + "?user=" + user;
}

function selectOption(sel) {
    qs(".inp-wrap .inp-sel", sel.parentElement).value = sel.value;
}
function changeSelectValue(sel, val) {
    sel.value = val;
    selectOption(sel);
}
function enableSelect(sel, disable) {
    var boo = Boolean(disable);
    sel.disabled = boo;
    qs(".inp-wrap .inp-sel", sel.parentElement).disabled = boo;
    if (boo) {
        addClass(sel.parentElement, "disabled");
    } else {
        removeClass(sel.parentElement, "disabled");
    }
}
function toggleClassInputError(el, noError) {
    var inpWrap = qs(".inp-wrap", el.parentElement);
    var inpSel = qs(".inp-sel", inpWrap);
    if (!noError) {
        addClass(el, "alert");
        if (inpSel) {
            addClass(inpWrap, "alert");
            addClass(inpSel, "alert");
        }
    } else {
        removeClass(el, "alert");
        if (inpSel) {
            removeClass(inpWrap, "alert");
            removeClass(inpSel, "alert");
        }
    }
}

function siteAjaxError() {
    popErrorSite("errorMessageAjaxSite");
    document.getElementById("errorMessageAjaxSite").innerHTML = lang === "fr" 
            ? "Une erreur s'est produite pendant le proccessus. Veuillez r�-essayer." 
            : "An error occurred during the process. Please try again.";
}
function addToCart(data, callback) {
    if (data && data !== "") {
        ajax("/action/shopAddCart?ajax=true&" + data, function(response) {
            if (response.match("success")) {
                callback(response);
            } else {
                siteAjaxError();
            }
        }, true);
    }
}
function clearCart(e, callback) {
    if (e) e.preventDefault();
    siteAjax("/action/ajaxAddCart?clear", function(response) {
        if (response.match("success")) {
            if (callback) {
                callback(response);
            } else {
                reloadPage();
            }
        } else {
            siteAjaxError();
        }
    });
}
function nextStepPayment(e) {
    if (e) e.preventDefault();
    
    var form = document.getElementById(this.getAttribute("data-form"));
    var valid = false;

    if ($(this).attr('data-form') === 'payment-step3' && $(this).hasClass('update-pers-newsletter')) {
        var url = '/action/updatePerson?field12=true&ajax=true';
    
        siteAjax(url, function(response) {console.log(response);});
    }
    
    if (qs(".cc-types", form)) {
        valid = chkCCForm(form.id);
    } else {
        valid = chkReqFields(form);
    }
    if (valid) {
        if (form.id === "payment-step1") {
            try {
                document.getElementById("paUsername").value = getElementByName(form, "email").value;
            } catch (notForceAccount) {}
        }
        ajaxBlackout(true);
        siteAjax(form.action + "?ajax=true&" + $(form).serialize(), reloadPage);
    }
}
function backStepPayment(e) {
    if (e) e.preventDefault();
    
    var it = this === window ? e.target : this;
    var form = document.getElementById("payment-backstep");
    
    if (it.hasAttribute("data-step")) {
        getElementByName(form, "step").value = it.getAttribute("data-step");
    }
    ajaxBlackout(true);
    siteAjax(form.action + "?ajax=true&" + $(form).serialize(), reloadPage);
}
function resetPayment(e) {
    if (e) e.preventDefault();
    
    var it = this === window ? e.target : this;
    var form = document.getElementById("payment-backstep");
    
    if (it.hasAttribute("data-step")) {
        getElementByName(form, "step").value = it.getAttribute("data-step");
    }
    ajaxBlackout(true);
    siteAjax(form.action + "?ajax=true&" + $(form).serialize(), function() {
        updateSVar(it.getAttribute("data-session"), "", function() {
            location.href = it.href;
        });
    });
}

function chkCCForm(id, submit) {
    var valid = true,
        form = document.getElementById(id),
        type = form.querySelector(".cc-types"),
        inputs = form.querySelectorAll(".required"),
        selY = form.querySelector(".cc-expy"),
        selM = form.querySelector(".cc-expm"),
        yy = selY.value,
        mm = selM.value,
        currY = selY.parentElement.parentElement.getAttribute("data-now"),
        currM = selM.parentElement.parentElement.getAttribute("data-now");
    
    if (type.value === "") {
        toggleClassInputError(type);
        type.parentElement.nextElementSibling.style.display = "block";
        valid = false;
    } else {
        toggleClassInputError(type, true);
        type.parentElement.nextElementSibling.style.display = "none";
    }
    for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        var a = inp.value;
        var nO = /^[0-9]*$/.test(a);
        var ex = /phone|email/.test(inp.name);
        var sc = (inp.name === "cvv2");
        var msg = inp.parentElement.nextElementSibling;
        
        if(!a || !nO && !ex || sc && a.length < 3) {
            toggleClassInputError(inp);
            if(msg) msg.style.display = "block";
            valid = false;
        } else {
            toggleClassInputError(inp, true);
            if(msg) msg.style.display = "none";
        }
    }
    if(parseInt(mm) < parseInt(currM) && yy === currY) {
        form.querySelector(".expError").style.display = "block";
        valid = false;
    } else {
        form.querySelector(".expError").style.display = "none";
    }
    
    if (submit && valid) form.submit();
    
    return valid;
}
function chkAccForm(form) {
    var $form = $(form);
    var valid = true;
    
    $form.find(".required").each(function() {
        var $inp = $(this);
        var $err = $inp.closest(".field").find(".errorMessage");
        var val = $inp.val().trim().replace(/\s+/g, " ");
        var isEmpty = val === "";
        var pass = true;

        switch ($inp.attr("name")) {
            case "firstName": 
            case "lastName": 
            case "city":
                pass = chkNameField(val) && !isEmpty;
                if (pass) val = sanitizeName(val);
                break;
            case "phone":
            case "phoneNumber":
                pass = chkPhoneNumber(val);
                if (pass) val = sanitizePhone(val);
                break;
            case "email":
                val = val.toLowerCase();
                pass = checkEmail(val);
                break;
            case "postalCode":
                val = val.toUpperCase().replace(" ", "");
                pass = !isEmpty;
                if (pass) {
                    var country = $("#acntCountry").val();
                    if (country === "CA") pass = canadaPC(val);
                    if (country === "US") pass = usaZIP(val);
                }
                break;
            case "street2":
            case "password": 
                break;
            default:
                pass = !isEmpty;
                break;
        }
        $inp.val(val);
        if (!pass) {
            valid = false;
            $inp.addClass("alert");
            $err.show();
        } else {
            $inp.removeClass("alert");
            $err.hide();
        }
    });
    if (valid) $form[0].submit();
}

function openWindowWithInfo(e) {
    var wid = this.getAttribute("data-id");
    var info = this.getAttribute("data-info").split(":");
    qs(".info-name", document.getElementById(wid)).innerHTML = info[1];
    qs(".info-id", document.getElementById(wid)).value = info[0];
    openWindow(wid, true);
    forEach(qsa("#" + wid + " .inp-txt"), function(el) {
        el.value = "";
    });
}
function displayWindowWithInfo() {
    var winEl = document.getElementById(this.getAttribute("data-id"));
    var info = this.getAttribute("data-info").split(":");
    qs(".info-name", winEl).innerHTML = info[1];
    qs(".info-id", winEl).value = info[0];
    winEl.style.display = "block";
    forEach(qsa(".inp-txt", winEl), function(el) {
        el.value = "";
    });
}

/* OLD */
function editAffiliate(btn, cancel) {
    var ctn = getAncestor(btn, "pa-affiliate-info");
    if (!cancel) {
        getElementByName(ctn, "field8").value = qs(".targ-na", ctn).textContent;
        getElementByName(ctn, "field9").value = qs(".targ-em", ctn).textContent;
        addClass(ctn, "modeEdit");
        addClass(qs(".targ-output", ctn), "none");
        removeClass(qs(".targ-input", ctn), "none");
        addClass(qs(".a-mod", ctn), "none");
        addClass(qs(".a-del", ctn), "none");
        removeClass(qs(".a-no", ctn), "none");
        removeClass(qs(".a-ok", ctn), "none");
    } else {
        removeClass(ctn, "modeEdit");
        removeClass(qs(".targ-output", ctn), "none");
        addClass(qs(".targ-input", ctn), "none");
        removeClass(qs(".a-mod", ctn), "none");
        removeClass(qs(".a-del", ctn), "none");
        addClass(qs(".a-no", ctn), "none");
        addClass(qs(".a-ok", ctn), "none");
    }
}

function editAffiliateSubAccount(btn, cancel) {
    var ctn = getAncestor(btn, "pa-affiliate-info");
    if (!cancel) {
        addClass(ctn, "modeEdit");
        addClass(qs(".targ-output", ctn), "none");
        removeClass(qs(".targ-input", ctn), "none");
        addClass(qs(".a-mod", ctn), "none");
        addClass(qs(".a-del", ctn), "none");
        removeClass(qs(".a-no", ctn), "none");
        removeClass(qs(".a-ok", ctn), "none");
    } else {
        removeClass(ctn, "modeEdit");
        removeClass(qs(".targ-output", ctn), "none");
        addClass(qs(".targ-input", ctn), "none");
        removeClass(qs(".a-mod", ctn), "none");
        removeClass(qs(".a-del", ctn), "none");
        addClass(qs(".a-no", ctn), "none");
        addClass(qs(".a-ok", ctn), "none");
    }
}

/* OLD */
function saveAffiliate(btn) {
    var ctn = getAncestor(btn, "pa-affiliate-info"),
        data = "?ajax=true";

    forEach(qsa(".targ-input input", ctn), function(inp) {
        data += "&" + inp.name + "=" + inp.value;
    });
    ajax("/action/updatePersonFields" + encodeURI(data), function(response) {
        if (response.trim() === "success") {
            editAffiliate(btn, true);
            removeClass(ctn, "empty");
            qs(".targ-na", ctn).innerHTML = getElementByName(ctn, "field8").value;
            qs(".targ-em", ctn).innerHTML = getElementByName(ctn, "field9").value;
        }
    }, true);
}

function saveAffiliateSubAccount(btn) {
    var ctn = getAncestor(btn, "pa-affiliate-info"),
            data = "?ajax=true",
            extra = "",
            username = "",
            id = "",
            changePwd = false;

    forEach(qsa(".targ-input input, .targ-input select", ctn), function (inp) {
        if (inp.type === "checkbox" || inp.type === "radio") {
            if (inp.checked) {
                extra += inp.name + SEP2 + inp.value + SEP;
            }
        } else if (inp.name === "email") {
            username = inp.value;
            data += "&username=" + encodeURIComponent(inp.value);
        } else if (inp.name === "password") {
            if (inp.value.trim() !== "") {
                changePwd = true;
                data += "&password=" + encodeURIComponent(inp.value);
            }
        } else if (inp.name === "personId") {
            data += "&" + inp.name + "=" + inp.value;
        } else if (inp.name === "id" && inp.value.trim() !== "") {
            data += "&" + inp.name + "=" + inp.value.trim();
            id = inp.value.trim();
        } else if (inp.name && inp.name !== "") {
            extra += inp.name + SEP2 + inp.value + SEP;
        }
    });
    if (id === "" && !changePwd) {
        data += "&password=" + makeRand(10);
    }
    data += "&extraData=" + extra;
    
    ajax("/action/manageSubAccounts" + encodeURI(data), function (response) {
        if (response.trim().indexOf("success") !== -1) {
            editAffiliateSubAccount(btn, true);
            removeClass(ctn, "empty");
            evaluateExtraData(ctn.getAttribute("data-id"), extra, username);
            $(ctn).find("input[name=id]").val(response.substring(8));
            ajax("/action/mailchimpSyncUser?ajax=true&id=" + id, void0, true);
        }
    }, true);
}

function formatData(o){
    if(getElementByName(o, "user-fName") !== null && getElementByName(o, "user-fName").value !== ''){
        var extra = "firstName" + SEP2 + getElementByName(o, "user-fName").value + SEP;
        extra += "lastName" + SEP2 + getElementByName(o, "user-lName").value + SEP;
        getElementByName(o, "extraData1").value = extra;
        getElementByName(o, "password1").value = makeRand(10);
    } else {
        getElementByName(o, "extraData1").value = "";
        getElementByName(o, "password1").value = "";        
    }
    
    chkFormO(o);
}

function compileUserInfos(o){
    var username = "";
    var data = "";
    var extra = "";
    forEach(qsa("input, select", o), function(inp) {
        if(inp.name !== 'extraData' && inp.name !== 'pageName' && inp.name !== 'id' && inp.name !== 'username'){
            if(inp.name === 'email'){
                username = inp.value;
                data += "&username="+inp.value;
            } else if(inp.name === 'personId'){
                data += "&" + inp.name + "=" + inp.value;
            } else if(inp.name === 'id' && inp.value.trim() !== ''){
                data += "&" + inp.name + "=" + inp.value;
            } else{
                if(inp.name === ''){
                    //                extra += "null" + SEP2 + inp.value + SEP;
                } else {
                    extra += inp.name + SEP2 + inp.value + SEP;
                }
            }
        }
    });
    
    getElementByName(o, "extraData").value = extra;
    getElementByName(o, "username").value = username;
    
    chkForm(o);
}

function makeRand(size) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < size; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

/* Update fields */
function evaluateExtraData(t,data, username){
    var ctn = qs("."+t);
    var ds = data.split(SEP);
    for(var i=0 ; i< ds.length ; i++){
        try{
            var d = ds[i].split(SEP2);
            var type = getElementByName(ctn, d[0]).nodeName;
            qs(".targ-"+d[0], ctn).innerHTML = d[1]+" ";
            if(type === "SELECT"){ 
                changeSelectValue(getElementByName(ctn, d[0]), d[1]);
            } else {
                getElementByName(ctn, d[0]).value = d[1];
            }
        }catch(e){
//            console.log(e);
        }
    }
    if(username !== undefined){ 
        qs(".targ-username", ctn).innerHTML = username;    
    }
}

function deleteAffiliate(btn) {
    var ctn = getAncestor(btn, "pa-affiliate-info"),
        personId = $(ctn).find('input[name=personId]').val(),
        id = $(ctn).find('input[name=id]').val(),
        data = "?ajax=true&delete=true&personId=" + personId + '&id=' + id;

    ajax("/action/manageSubAccounts" + encodeURI(data), function(response) {
        if (response.trim().indexOf("success") !== -1) {
            $(ctn).find('.targ-output div:not(.targ-na)').html('');
            $(ctn).find('.targ-output .targ-na span').html('');
            $(ctn).find('.a-del').addClass('none');
            $(ctn).find('input[name=id]').val('');
            $(ctn).find('.targ-input .inp-ctn input, .targ-input .inp-ctn select').val('');
        }
    }, true);
}

function toggleDisplayPw(e) {
    var inp = qs(".display-pw-input", getAncestor(this, "display-pw-ctn"));
    inp.type = this.checked ? "text" : "password";
}

function deleteNews(btn) {
    var datas = getDataSet(btn.parentElement);
    for (var k in datas) {
        updateLabel(datas[k], "", lang, void0, true);
    }
    document.getElementById(datas.idB).style.display = "none";
}
function editNews(btn) {
    var datas = getDataSet(btn.parentElement),
        box = document.getElementById(datas.idB),
        editor = document.getElementById(datas.idE);

    getElementByName(editor, "date").value = qs(".news-date", box).innerHTML;
    getElementByName(editor, "title").value = qs(".news-title", box).innerHTML;
    tinymce.get(getElementByName(editor, "content").id).setContent(qs(".news-content", box).innerHTML);
    scrollToEl(editor);
}
function saveNews(form, boxId) {
    var valid = true,
        co1 = {},
        co2 = {};
    
    forEach(qsa(".required", form), function(inp) {
        var v = "";
        if (inp.tagName === "TEXTAREA") {
            if (tinymce.get(inp.id).getBody().textContent.trim() === "") valid = false;
            tinymce.get(inp.id).save();
        }
        v = inp.value;
        if (v === "") valid = false;
        co1[inp.getAttribute("data-key")] = v;
        co2[inp.name] = v;
    });
    
    if (valid) {
        updateMultiLabels(co1, lang, function() {
            $("html, body").animate({scrollTop: 0});
            var box = document.getElementById(boxId);
            box.style.display = "block";
            for (var p in co2) {
                qs(".news-" + p, box).innerHTML = co2[p];
            }
        }, true);
    }
}

function beginSubscriptionCheckout(e, forward) {
    var pageName = forward || this.getAttribute("data-forward");
    updateSVar("membershipCheckout", "true", function() {
        location.pathname = pageName;
    });
}
function updateCartTotal(sub, amt, tax1, tax2) {
    qs(".cart-total-sub").innerHTML = formatMoney(sub).replace("$", "") + " $";
    qs(".cart-total-amt").innerHTML = amt + " $";
    qs(".cart-total-tax1").innerHTML = tax1 + " $";
    qs(".cart-total-tax2").innerHTML = tax2 + " $";
}
function loadJsonCartTotal(response) {
    var cartObj = typeof response === "string" ? JSON.parse(response) : response,
        tot = cartObj[1].total,
        tax1 = cartObj[1].TPS || cartObj[1].GST,
        tax2 = cartObj[1].TVQ || cartObj[1].QST,
        sub = parseDecimal(tot) - parseDecimal(tax1) - parseDecimal(tax2),
        promoCode = cartObj[1].promoCode,
        promoCodeVal = cartObj[1].promoValue;

    updateCartTotal(sub, tot, tax1, tax2);
    
    if (promoCode && promoCode !== "") {
        try {
            removeClass(qs(".promo-code-ctn"), "hide");
            qs(".cart-total-promo-text").innerHTML = promoCode;
            qs(".cart-total-promo-amt").innerHTML = promoCodeVal + " $";
        } catch(err) {
            console.error(err);
        }
    }
}
function ajaxLoadCart() {
    ajax("/action/shopJsonCart", function(response) {
        var cartObj = JSON.parse(response);

        for (var i = 0; i < cartObj[0].length; i++) {
            var cartItem = cartObj[0][i],
                row = document.getElementById("product_" + cartItem.productId);

            qs(".csi-price", row).innerHTML = cartItem.price + " $";
            qs(".csi-qty", row).innerHTML = cartItem.quantity + (qs(".csi-qty", row).getAttribute("data-unit") || "");
            row.setAttribute("data-cart-id", cartItem.id);
            if (row.hasAttribute("data-main")) {
                qs(".csi-data").innerHTML = cartItem.data;
            } else {
                qs(".csi-name", row).innerHTML = "<div>" + eval("'" + cartItem.name + "'") + "</div>";// + eval("'" + (cartItem.data || "") + "'");
            }
        }
        loadJsonCartTotal(response);

        var startBtn = qs(".payment-start-btn");
        if (startBtn && hasClass(startBtn, "disabled")) {
            removeClass(startBtn, "disabled");
            if(!hasClass(startBtn, "evolve-btn")){
                startBtn.addEventListener("click", beginSubscriptionCheckout);
            }
        }
    }, true);
}
function removeMixedProductsFromCart(callback) {
    var el = document.getElementById("cartIds_acceptOnly");
    if (el) {
        ajax("/action/shopJsonCart", function(response) {
            var arr = el.value.split(","),
                jo = JSON.parse(response),
                i = 0,
                count = 0,
                o;
            
            var _complete = function() {
                count++;
                if (count === jo[0].length && callback) callback();
            };
            
            if (!jo[0] || jo[0].length === 0) {
                count = -1;
                _complete();
            } else {
                for (; i < jo[0].length; i++) {
                    o = jo[0][i];
                    if (arr.indexOf(o.productId) === -1) {
                        addToCart("remove=true&productId=" + o.id, _complete);
                    } else {
                        _complete();
                    }
                }
            }
        });
    }
}

function chooseProduct(it) {
    var ctn = it.parentElement,
        aCls = "selected";

    if (!hasClass(it, aCls)) {
        removeClass(qs("." + aCls, ctn), aCls);
        addClass(it, aCls);
        
        var checkoutBtn = qs(".payment-checkout-btn");
        if (checkoutBtn && hasClass(checkoutBtn, "disabled")) {
            removeClass(checkoutBtn, "disabled");
            checkoutBtn.addEventListener("click", function(e) {
                //Do nothing?
            });
        }
    }
}
function chooseProductAjax(it, pid, qty, opt) {
    var ctn = it.parentElement,
        wCls = "loadwait",
        aCls = "selected",
        prevEl = qs("." + aCls, ctn);

    var _addCart = function() {
        addToCart("productId=" + pid + "&quantity=" + qty + "&option1=" + opt, function(response) {
            removeClass(ctn, wCls);
            if (response.substr(response.indexOf(":") + 1).trim() !== "") {
                addClass(it, aCls);
                // Load cart data to interface
                removeMixedProductsFromCart(ajaxLoadCart);
            } else {
                siteAjaxError();
            }
        });
    };
    
    if (!hasClass(ctn, wCls)) {
        addClass(ctn, wCls);
        if (prevEl) {
            var cartItemRow = document.getElementById("product_" + pid);
            // Remove the current product
            addToCart("remove=true&productId=" + cartItemRow.getAttribute("data-cart-id"), function(response) {
                if (!hasClass(it, aCls)) {
                    // Add the new selected product to cart
                    _addCart();
                } else {
                    removeClass(ctn, wCls);
                    removeMixedProductsFromCart(ajaxLoadCart);
                    qs(".csi-price", cartItemRow).innerHTML = "0 $";
                    qs(".csi-qty", cartItemRow).innerHTML = "0" + (qs(".csi-qty", cartItemRow).getAttribute("data-unit") || "");
                    cartItemRow.setAttribute("data-cart-id", "");
                    qs(".csi-data").innerHTML = "0";
                }
                removeClass(prevEl, aCls);
            });
        } else {
            _addCart();
        }
    }
}
function chooseAffiliateAjax(e) {
    var t = this,
        va = t.value.split("-"),
        cartId = t.getAttribute("data-id");
    
    if (t.checked || cartId === null || cartId === "") {
        addToCart("productId=" + va[0] + "&quantity=" + va[1] + "&data=/", function (response) {
            cartId = response.substr(response.indexOf(":") + 1).trim();
            if (cartId !== "-1") {
                t.setAttribute("data-id", cartId);
                document.getElementById("product_" + va[0]).style.display = "";
                // Load cart data to interface
                removeMixedProductsFromCart(ajaxLoadCart);
            } else {
                siteAjaxError();
            }
        });
    } else {
        addToCart("productId=" + cartId + "&remove=true", function (response) {
            if (response.indexOf("success") !== "-1") {
                t.removeAttribute("data-id");
                document.getElementById("product_" + va[0]).style.display = "none";
                // Load cart data to interface
                removeMixedProductsFromCart(ajaxLoadCart);
            } else {
                siteAjaxError();
            }
        });
    }
}
function addSubscriptionAA(e, forward, ctnClass) {
    var ctn = qs("."+ctnClass),//".pa-new-subs"
        cel = qs(".cellar-option-block.selected", ctn),
        affCb = qs(".affiliate-checker", ctn),
        affFName = qs(".affiliate-option-info .person-fname", ctn).value.trim(),
        affLName = qs(".affiliate-option-info .person-lname", ctn).value.trim(),
        affEmail = qs(".affiliate-option-info .person-email", ctn).value.trim(),
        addCelComplete = false,
        addAffComplete = !affCb.checked;
     
    if (!cel || (affCb.checked && (affFName === "" || affLName === "" || affEmail === "")) || hasClass(ctn, "processing")) {
        removeClass(qs(".errmsg-subs-choice", ctn), "none");
        return false;
    }
    addClass(qs(".errmsg-subs-choice", ctn), "none");
    addClass(ctn, "processing");
    
    var _success = function() {
        if (addCelComplete && addAffComplete) {
            ajaxBlackout(true);
            location.href = forward;
        }
    };
    
    // Clear reservations and other products for subscription-only checkout
    clearCart(e, function() {        
        addToCart("productId=" + cel.getAttribute("data-id") + "&option1=" + cel.getAttribute("data-option"), function(response1) {
            if (response1.substr(response1.indexOf(":") + 1).trim() !== "-1") {
                addCelComplete = true;
                _success();
            } else {
                siteAjaxError();
            }
        });
        if (affCb.checked) {
            updateSVar("affFName", affFName, function(){                
                updateSVar("affLName", affLName, function(){
                    updateSVar("affEmail", affEmail, function(){                        
                        var data = "<affiliate>" + affFName + " " + affLName + " <br/>" + affEmail + "</affiliate>";
                        var a = affCb.value.split("-");
                        
                        addToCart("productId=" + a[0] + "&quantity=" + a[1] + "&data=" + encodeURIComponent(data), function(response2) {
                            if (response2.substr(response2.indexOf(":") + 1).trim() !== "-1") {
                                addAffComplete = true;
                                _success();
                            } else {
                                siteAjaxError();
                            }
                        });
                    });
                });
            });
        } else {            
            updateSVar("affFName", "", function(){        
                updateSVar("affLName", "", function(){
                    updateSVar("affEmail", "", void0);
                });
            });
        }
    });
}
function addDirectSubscriptionAA(e, t, ctnClass) {
    var ctn = qs("."+ctnClass),//".pa-new-subs"
        cel = qs(".cellar-option-block.selected", ctn),
        affCb = qs(".affiliate-checker", ctn),
        affFName = qs(".affiliate-option-info .person-fname", ctn).value.trim(),
        affLName = qs(".affiliate-option-info .person-lname", ctn).value.trim(),
        affEmail = qs(".affiliate-option-info .person-email", ctn).value.trim(),
        addAffComplete = !affCb.checked;
     
    if ((!cel && !affCb.checked) || (affCb.checked && (affFName === "" || affLName === "" || affEmail === ""))) {
        removeClass(qs(".errmsg-subs-choice", ctn), "none");
        return false;
    }
    addClass(qs(".errmsg-subs-choice", ctn), "none");
    ajaxBlackout(true);
    
    var _success = function() {
        if (addAffComplete) {
            beginSubscriptionCheckout.call(t);
        }
    };
    var _addCart = function() {
        var data = "<affiliate>" + affFName + " " + affLName + " <br/>" + affEmail + "</affiliate>";
        var a = affCb.value.split("-");
        
        addToCart("productId=" + a[0] + "&quantity=" + a[1] + "&data=" + encodeURIComponent(data), function (response2) {
            if (response2.substr(response2.indexOf(":") + 1).trim() !== "-1") {
                addAffComplete = true;
                _success();
            } else {
                siteAjaxError();
            }
        });
    };
    
    if (affCb.checked) {
        var inCart = affCb.getAttribute("data-id");  
        updateSVar("affFName", affFName, function(){     
            updateSVar("affLName", affLName, function() {
                updateSVar("affEmail", affEmail, function () {
                    if (inCart !== null && inCart !== "") {
                        // Remove draft product and add a new one in order to have its cart data updated
                        addToCart("productId=" + inCart + "&remove=true", function (response2) {
                            if (response2.indexOf("success") !== "-1") {
                               _addCart();
                            } else {
                                siteAjaxError();
                            }
                        });
                    } else {
                        _addCart();
                    }
                }, true);
            }, true);
        }, true);
    } else {            
        updateSVar("affFName", "", function(){        
            updateSVar("affLName", "", function(){
                updateSVar("affEmail", "", function(){ 
                    var rId = affCb.getAttribute("data-id");
                    if(rId !== null && rId !== ""){
                        addToCart("productId=" + rId + "&remove=true", function(response2) {
                            if (response2.indexOf("success") !== "-1") {
                                addAffComplete = true;
                                _success();
                            } else {
                                siteAjaxError();
                            }
                        });
                    } else {
                        addAffComplete = true;
                        _success();
                    }
                }, true);
            }, true);
        }, true);
    }
}
function updateMemberAfterPayment(json) {
    var jo = typeof json === "string" ? JSON.parse(json) : json;
    var str = "?ajax=true";
    var personId = "";
    var affFName = "";
    var affLName = "";
    var affEmail = "";
    
    for (var p in jo) {
        if (p === "affFName") {
            affFName = jo[p];
        } else if (p === "affLName") {
            affLName = jo[p];
        } else if (p === "username") {
            affEmail = jo[p];
        } else {
            if (p === "id") {
                personId = jo[p];
            }
            str += "&" + p + "=" + jo[p];
        }
    }
    ajax("/action/updatePerson" + str, function (response) {
        replaceURL("success", "1");
        removeClass(document.getElementById("payment-step4"), "none");
        addClass(document.getElementById("payment-prefinal"), "none");
        if (affFName !== "" && affLName !== "" && affEmail !== "") {
            var url = "/action/manageSubAccounts?ajax=true";
            url += "&personId=" + personId;
            url += "&username=" + affEmail;
            url += "&password=" + makeRand(10);
            url += "&extraData=firstName" + SEP2 + affFName + SEP + "lastName" + SEP2 + affLName;

            ajax(url, function (response) {
                if (response.indexOf("success") !== -1) {
                    var id = response.trim().substr(response.indexOf("-") + 1);
                    ajax("/action/mailchimpSyncUser?ajax=true&id=" + id, void0, true);
                    
                    updateSVar("affFName", "", function () {
                        updateSVar("affLName", "", function () {
                            updateSVar("affEmail", "", function () {
                            }, true);
                        }, true);
                    }, true);
                }
            }, true);
        }
    });
}

function initInstafeed() {
    var feed = new Instafeed({
       get: 'user', 
       userId: '5845375490', // parloir
       sortBy: 'most-recent',
       links: true,
       limit: 5,
       resolution: 'standard_resolution',
       clientId: 'b66282674a5249dfa7591b6bcbbc464c', //parloir
       accessToken: '5845375490.1677ed0.f0c6235614d4443991aa10bfc39635bb', //parloir
       template: '<div class="instafeed-img-ctn rel"><a href="{{link}}" class="instafeed-link"><div class="background-img" style="background-image:url({{image}});" class="instafeed-img"></div></a></div>',
       after: initInstafeedSlick
   });
   feed.run();
}

function initInstafeedSlick() {
    $('#instafeed').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
        pauseOnFocus:false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
}

$.fn.slideFadeIn  = function(speed, easing, callback) {
        return this.animate({opacity: 'show', height: 'show'}, speed, easing, callback);
}; 

$.fn.slideFadeOut  = function(speed, easing, callback) {
        return this.animate({opacity: 'hide', height: 'hide'}, speed, easing, callback);
}; 

function portraitDescSlideFadeIn() {
    var t = $(this);
    if (t.find('.resp-detection').css('visibility') === 'visible') {
        t.find('.one-portrait-content.abs .one-portrait-description-ctn').slideFadeIn();
    }
}

function portraitDescSlideFadeOut() {
    var t = $(this);
    if (t.find('.resp-detection').css('visibility') === 'visible') {
        $(this).find('.one-portrait-content.abs .one-portrait-description-ctn').slideFadeOut();
    }
}

function togglePortraitRespDesc() {
    var t = $(this);
    var parent = t.closest('.one-portrait-outer-ctn');

    if (!parent.hasClass('open')) {
        parent.addClass('open');
        parent.find('.text').fadeOut(300, function() {
            parent.find('.icon').fadeIn(300);
        });
    } else {
        parent.removeClass('open');
        parent.find('.icon').fadeOut(300, function() {
            parent.find('.text').fadeIn(300);
        });
    }

    parent.find('.one-portrait-content.responsive').slideToggle();
}

function toggleRoomChoice() {
    var t = $(this);
    var id = t.attr('data-id');
    var parent = t.closest('.pa-content');
    var opened = parent.find('.room-choice-content.open');
    var delay = 0;
    
    if (!id || id === '') return;
    
    $('.room-choice-btn[data-id!=' + id + ']').addClass('inactive');
    if (opened.length && opened.attr('data-id') !== id) {
        delay = 300;
        opened.slideUp(delay, function() {
            $(this).removeClass('open');
            t.removeClass('inactive');
        });
    } else if (opened.length && opened.attr('data-id') === id) {
        $('.room-choice-btn').removeClass('inactive');
    }

    setTimeout(function() {
        $('.room-choice-content[data-id=' + id + ']').slideToggle().toggleClass('open');
    }, delay);
}

function moveEditableText() {
    var text = $('.editable-text-ctn');
    
    text.each(function () {
        var t = $(this);
        var ctn = t.parent('.js-editable-container');
        var pos;
        var receiver;
        
        if (t.attr('data-position') !== 0) {
            pos = t.attr('data-position');
        } else {
            pos = 1;
        }
        
        if ($('.js-editable-receiver[data-editable-receiver-position = '+pos+']', ctn).length !== 0) {
            receiver = $('.js-editable-receiver[data-editable-receiver-position = '+pos+']', ctn);
        } else {
            receiver = $('.js-editable-receiver', ctn);
        }
        
        if ($('.js-editable-receiver[data-editable-receiver-position]', ctn).length !== 0 && 
            $('.js-editable-receiver[data-editable-receiver-position = '+pos+']', ctn).length === 0 && 
            t.attr('data-position') !== '') {
            t.remove();
        } else if (ctn.length !== 0 && receiver.length !== 0) {
            t.detach().appendTo(receiver);
        }
    });
}

function addEditableTextClass() {
    var editableText = $('div[id^=displayTextInnerWindow]');
    $('.componentContainerDiv').addClass('js-editable-container');
    
    editableText.each(function () {
        var t = $(this);
        var parent = t.parent();
        
        parent.addClass('editable-text-ctn');
    });
}

function addEditableTextPosition() {
    $('.js-editable-container').each(function () {
        var index = 1;
        var t = $(this);
        
        $('.editable-text-ctn', t).each(function () {
            var t = $(this);
            
            t.attr('data-position', index);
            
            index++;
        });
    });
}

function forgotPassword() {
    var email = document.getElementById('forgotEmail').value;
    var validate = /\w@\w/;
    
    if(email.match(validate)) 
        ajax('/action/forgotPassword?email=' + encodeURIComponent(email), forgotPasswordComplete);
}
function forgotPasswordComplete() {
    document.getElementById("forgotEmailAddress").innerHTML = document.getElementById("forgotEmail").value;
    document.getElementById('forgotEmailMessage').style.display = "none";
    document.getElementById('passwordSent').style.display = "block";
}
function forgotPasswordRefresh() {
    document.getElementById('forgotEmailMessage').style.display = "block";
    document.getElementById('passwordSent').style.display = "none";
}
var formCheckoutStoreCardChange = function () {
    var t = $(this);
    if (t.is(':checked')) {
        updateSVar("storeCard", "true", function(){}, false);
        $('input[name="storeCard"]').val('true');
    } else {
        updateSVar("storeCard", "", function(){}, false);
        $('input[name="storeCard"]').val('false');
    }
};
function addPromoCode() {
    var t = $(this);
    var code = t.closest('.promo-code-ctn').find('input[name=code]').val();

    var url = '/action/shopApplyPromo';
    url += '?code=' + code;
    url += '&ajax=true';

    var obj = ajax(url, function(response) {
        if (response.indexOf('invalid') !== -1) {
            ajax("/action/shopJsonCart", loadJsonCartTotal, true);
        }
    }, true);
}

//#DEPRECATED see initContactForm
function sendRDVEmail(form) {
    var $form = $(form);
    if (chkReqFields(form) && !$form.hasClass("processing")) {
        $form.addClass("processing");
        ajax(form.action + "?ajax=true&" + $form.serialize(), function(response) {
            $form.slideUp();
            $("#rdv_msg_success").slideDown();
        }, true);
    }
}

function submitAjaxForm(form) {
    if (chkReqFields(form)) {
        var data = $(form).serialize();
        ajax(form.action + "?" + data, function(response) {
            qs("#renewSubscriptionSuccessWindow .response-text").innerHTML = response.replace("***Moneris Response: ", "");
            openWindow("renewSubscriptionSuccessWindow");
        });
    }
}

function initContactForm() {
    var btn = document.querySelector(".bundles-form-btn-ctn button");
    if (btn && !!grecaptcha) {
        grecaptcha.ready(function() {
            grecaptcha.render(btn, {
                'sitekey': '6LfToZ4UAAAAAIFjcbWb5ErC6fQta1Ib5KvTESBD',
                'callback': function (response) {
                    var $form = $("#contactUsForm");
                    if ($form.hasClass("processing")) {
                        return;
                    }
                    if (chkReqFields($form[0])) {
                        if (!response) {
                            $form.find(".errmsg-recaptcha").slideDown(200);
                        } else {
                            $form.find(".errmsg-recaptcha").hide();
                            $form.addClass("processing");
                            
                            ajax(actionPath + "contactUs?ajax=true" + $form.serialize(), function() {
                                $form.removeClass("processing");
                                $form[0].reset();
                                grecaptcha.reset();
                                $form.slideUp();
                                $("#rdv_msg_success").slideDown();
                            }, true);
                        }
                    } else {
                        grecaptcha.reset();
                    }
                },
                'badge': 'inline'
            });
        });
    }
}

function showMoreCellarOptions(e) {
    var btn = e.currentTarget;
    var els = qsa(".cellar-option-block.hidden", getAncestor(btn, "cellar-options"));
    
    for (var i = 0; i < els.length && i < 4; i++) {
        var el = els[i];
        removeClass(el, "hidden");
    }
    // Remove the button since there are no more items to show
    if (i >= els.length) {
        btn.parentElement.removeChild(btn);
    }
}

/* READY TO INITIATE */
(function() {
    function run(fn) {try {fn();} catch (er) {console.warn(er);}}

    function initShowMoreBtn(t) {
        var textOuterCtn = $('.show-more-text-outer-ctn', t);
        var textCtn = $('.show-more-text-ctn', t);
        var showMoreBtnCtn = $('.show-more-text-btn-ctn', t);
        var showMoreBtn = $('.show-more-text-btn', t);
        
        if (textOuterCtn.height() < textCtn.height()) {
            showMoreBtnCtn.slideDown(300);
            showMoreBtn.click(showMoreText);
        }
    }
    
    function showMoreText() {
        var t = $(this);
        var parentCtn = t.closest('.show-more-text-and-btn-ctn');
        var currTextOuterCtn = parentCtn.find('.show-more-text-outer-ctn');
        var textHeight = parentCtn.find('.show-more-text-ctn').height();

        currTextOuterCtn.css('max-height', textHeight);
        t.closest('.show-more-text-btn-ctn').slideUp(300);

        setTimeout(function() {
            currTextOuterCtn.css('max-height', 'inherit'); // if resized
        }, 300);
    }

    function handleExtraItem(e) {
        var it = this,
            ctn = getAncestor(it, "reserve-food-item"),
            qty = $(it).closest('.input-side-ndi').find('.number-input').html(),
            d = getDataSet(ctn);

        var _insertItem = function(id) {
            var tb = qs(".cart-table"),
                tr;

            if ($(tb).find('.cri' + id).length) {
                _updateQty(id);
            } else {
                tr = tb.insertRow(tb.getElementsByClassName("cart-row-item").length);
                addClass(tr, "cri" + id);
                tr.innerHTML = "<td class=\"csi-name\">" + d.name + "</td><td class=\"csi-qty\">1</td>"
                        + "<td class=\"csi-price\">" + d.pricef + "</td>";
            }
        };

        var _removeItem = function(id) {
            var item = qs(".cri" + id);
            item.parentElement.removeChild(item);
        };

        var _updateQty = function(id) {
            var price = d.pricef.split(' $')[0].replace(',', '.');
            var newPrice = (parseInt(qty) * parseFloat(price)).toFixed(2) + ' $';

            $('.cart-table').find('.cri' + id).find('.csi-qty').html(qty);
            $('.cart-table').find('.cri' + id).find('.csi-price').html($('.cart-table').attr('data-lang') === 'fr' ? newPrice.replace('.', ',') : newPrice);
        };

        addClass(it, "loadwait");
        if ($(it).hasClass('add-extra-item') || $(it).hasClass('remove-extra-item') && qty !== '0') {
            addToCart("override=true&productId=" + d.pid + '&quantity=' + qty, function(response) {
                setTimeout(function() { removeClass(it, "loadwait"); }, 20);
                var res = response.trim().split(":");
                if (res[1] && res[1] !== "" && res[1] !== "-1") {
                    ajax("/action/shopJsonCart", loadJsonCartTotal, true);
                    if ($(it).hasClass('remove-extra-item')) {
                        _updateQty(d.cid);
                    } else {
                        _insertItem(res[1]);
                    }
                    setDataSet(ctn, "cid", res[1]);
                    $(".checkout-comment").slideDown(200);
                }
            });
        } else {
            addToCart("remove=true&productId=" + d.cid, function(response) {
                setTimeout(function() { removeClass(it, "loadwait"); }, 20);
                ajax("/action/shopJsonCart", loadJsonCartTotal, true);
                _removeItem(d.cid);
                setDataSet(ctn, "cid", "");
                if ($(".reserve-food-checker:checked").length === 0) {
                    $(".checkout-comment").slideUp(200);
                    $(".checkout-comment-box textarea").val("");
                }
            });
        }
    }

    function updateNewsletterInput() {
        var t = $(this);
        var input = t.closest('.newsletter-ctn').find('.newsletter-input');
        
        if (t.prop('checked') === true) {
            input.val(true);
        } else {
            input.val(false);
        }
    }

    function deleteRes() {
        $(this).closest('form').submit();
    }

    function changeFilter(e) {
        if (this.value === "") {
            location.search = removeQuery(this.name);
        } else {
            location.search = setQuery(this.name, this.value);
        }
    }
    
    function DOMReady(e) {
        // Init page cover
        run(function() {
            var pageCover = qs(".cover");
            if (pageCover) {
                pageCover.style.height = winH + "px";
                window.addEventListener("resize", function() {
                    pageCover.style.height = winH + "px";
                });
            }
        });

        // Init menu
        run(function() {
            setHoverBar();
            qs(".menu-btn").addEventListener("click", toggleMenu);
        });
        
        // Init recaptcha in contact/bundle form
        run(initContactForm);
        
        // Init affiliate checkbox
        bindEvent(".js-add-affiliate", "change", chooseAffiliateAjax);

        // Init checkout process
        forEach(qsa(".payment-next-btn"), function(btn) {
            btn.addEventListener("click", nextStepPayment);
        });
        forEach(qsa(".payment-cancel-btn"), function(btn) {
            btn.addEventListener("click", clearCart);
        });
        forEach(qsa(".checkout-process-step.past"), function(btn) {
            var ctn = qs(".checkout-process-step.current", btn.parentElement);
            var curStep = !ctn ? "" : ctn.getAttribute("data-step");
            if (btn.getAttribute("data-step") !== "0" && curStep !== "4") {
                btn.addEventListener("click", backStepPayment);
            }
            if (btn.hasAttribute("data-session")) {
                btn.addEventListener("click", function() {
                    updateSVar(this.getAttribute("data-session"), "", reloadPage);
                });
            } else if (btn.hasAttribute("data-href")) {
                btn.addEventListener("click", function() {
                    location.href = this.getAttribute("data-href");
                });
            }
        });
        forEach(qsa(".checkout-reset-btn"), function(btn) {
            btn.addEventListener("click", resetPayment);
        });
        forEach(qsa(".input-side-ndi"), function(el) {
            qs(".number-decr", el).addEventListener("click", function() {
                var node = qs(".number-input", el),
                    inp = this.parentElement.previousElementSibling,
                    cur = parseInt(inp.value),
                    min = parseInt(inp.min);

                cur--;
                if (min > cur) cur = min;
                node.innerHTML = inp.value = cur;
            });
            qs(".number-incr", el).addEventListener("click", function() {
                var node = qs(".number-input", el),
                    inp = this.parentElement.previousElementSibling,
                    cur = parseInt(inp.value),
                    max = parseInt(inp.max);

                cur++;
                if (max < cur) cur = max;
                node.innerHTML = inp.value = cur;
            });
        });
        forEach(qsa(".cc-use-choice"), function (cb) {
            cb.addEventListener("change", function (e) {
                var usc = document.getElementById("useStoredCard");
                if (this.value === "-1") {
                    usc.name = "";
                    $("#otherCard").slideDown().find(".derequired").each(function () {
                        $(this).removeClass("derequired").addClass("required");
                    });
                } else {
                    if (this.value === "1") {
                        usc.name = "useWalletCard";
                        usc.value = "1";
                    } else {
                        usc.name = "useCard";
                        usc.value = "true";
                    }
                    $("#otherCard").slideUp().find(".required").each(function () {
                        $(this).removeClass("required").addClass("derequired");
                    });
                }
            });
        });
        
        // Bind actions to buttons throughout account tables
        forEach(qsa(".act-delete-btn"), function(btn) {
            btn.addEventListener("click", openWindowWithInfo);
        });
        forEach(qsa(".act-password-btn"), function(btn) {
            btn.addEventListener("click", displayWindowWithInfo);
        });
        
        forEach(qsa(".accordion-toggle"), function(btn) {
            btn.addEventListener("click", toggleAccordion);
        });
        forEach(qsa(".display-pw-toggle"), function(cb) {
            cb.addEventListener("change", toggleDisplayPw);
        });
        
        // Init buttons to display info form
        forEach(qsa(".info-mod-btn"), function(btn) {
            btn.addEventListener("click", function(e) {
                var ctna = getAncestor(this, "info-mod-a"),
                    ctnb = qs(".info-mod-b", ctna.parentElement),
                    form = qs("form", ctnb);

                ctnb.style.display = "";
                forEach(qsa(".info-values input", ctna), function(inp) {
                    var targ = getElementByName(form, inp.getAttribute("data-name"));
                    if (hasClass(targ, "inp-sel")) {
                        changeSelectValue(targ, inp.value);
                    } else {
                        targ.value = inp.value;
                    }
                });
            });
        });
        // Init buttons to close info form
        forEach(qsa(".info-mod-cancel"), function(btn) {
            btn.addEventListener("click", function(e) {
                var ctnb = getAncestor(this, "info-mod-b");
                ctnb.style.display = "none";
            });
        });
        
        // Init checkboxes to add food products to cart
        forEach(qsa(".reserve-food-checker"), function(cb) {
            cb.addEventListener("change", function(e) {
                var it = this,
                    ctn = getAncestor(it, "reserve-food-item"),
                    d = getDataSet(ctn);

                var _insertItem = function(id) {
                    var tb = qs(".cart-table"),
                        tr = tb.insertRow(tb.getElementsByClassName("cart-row-item").length);

                    addClass(tr, "cri" + id);
                    tr.innerHTML = "<td class=\"csi-name\">" + d.name + "</td><td class=\"csi-qty\">1</td>"
                            + "<td class=\"csi-price\">" + d.pricef + "</td>";
                };

                var _removeItem = function(id) {
                    var item = qs(".cri" + id);
                    item.parentElement.removeChild(item);
                };

                addClass(it, "loadwait");
                if (it.checked) {
                    addToCart("override=true&productId=" + d.pid, function(response) {
                        setTimeout(function() { removeClass(it, "loadwait"); }, 20);
                        var res = response.trim().split(":");
                        if (res[1] && res[1] !== "" && res[1] !== "-1") {
                            ajax("/action/shopJsonCart", loadJsonCartTotal, true);
                            _insertItem(res[1]);
                            setDataSet(ctn, "cid", res[1]);
                            $(".checkout-comment").slideDown(200);
                        } else {
                            it.checked = false;
                        }
                    });
                } else {
                    addToCart("remove=true&productId=" + d.cid, function(response) {
                        setTimeout(function() { removeClass(it, "loadwait"); }, 20);
                        ajax("/action/shopJsonCart", loadJsonCartTotal, true);
                        _removeItem(d.cid);
                        setDataSet(ctn, "cid", "");
                        if ($(".reserve-food-checker:checked").length === 0) {
                            $(".checkout-comment").slideUp(200);
                            $(".checkout-comment-box textarea").val("");
                        }
                    });
                }
            });
            cb.addEventListener("click", function(e) {
                if (hasClass(this, "loadwait")) {
                    e.preventDefault();
                    return false;
                }
            });
        });

        forEach(qsa(".add-extra-item"), function(cb) {
            cb.addEventListener("click", handleExtraItem);
        });

        forEach(qsa(".remove-extra-item"), function(cb) {
            cb.addEventListener("click", handleExtraItem);
        });
        
        forEach(qsa(".pa-list-filter-year"), function(cb) {
            cb.addEventListener("change", changeFilter);
        });
        
        // Init View more options button in Evoluer/Upgrade
        bindEvent(".cellar-options-append-btn", "click", showMoreCellarOptions);
        
        // Init add to cart with product selection for subscription and upgrade
        bindEvent(".cellar-option-block:not(.byadmin)", "click", function(e) {
            var btn = e.currentTarget;
            var data = btn.dataset;
            chooseProductAjax(btn, data.id, data.qty, data.option);
        });
        bindEvent(".cellar-option-block.byadmin", "click", function(e) {
            chooseProduct(e.currentTarget);
        });
        
    }

    function DOMLoad(e) {
        if ($('#instafeed').length !== 0) {
            initInstafeed();
        }

        if ($('.checkout-payment').length !== 0 && !$("#cartIds_acceptOnly")[0]) {
            ajax("/action/shopJsonCart", loadJsonCartTotal, true);
        }
        
        $('.one-portrait-ctn').hover(portraitDescSlideFadeIn, portraitDescSlideFadeOut);
        $('.portrait-bio-btn').click(togglePortraitRespDesc);
        $('.room-choice-btn').click(toggleRoomChoice);
        $('.add-promo-code-btn').click(addPromoCode);
        $('.newsletter-checkbox').change(updateNewsletterInput);
        $('.confirm-delete-res').click(deleteRes);

        var jPlayer = $('.jPlayer');
        if (jPlayer.length !== 0 && !$('html').hasClass('mobile')) {
            jPlayer.each(function () {
                var t = $(this);
                var sourceMP4 = t.attr('data-video-mp4');
                
                t.jPlayer({
                    ready: function () {
                        $(this).jPlayer('setMedia', {
                            m4v: sourceMP4
                        }).jPlayer('play');
                        
                        $('video', $(this)).attr('data-keepplaying', 'data-keepplaying');
                    },
                    swfPath: "/static/assets/jquery.jplayer.swf",
                    supplied: "m4v",
                    muted: true,
                    fullscreen: true,
                    loop: true
                });
            });
        }
        
        addEditableTextClass();
        addEditableTextPosition();
        moveEditableText();

        $('.show-more-text-btn').click(showMoreText);

        $('.show-more-text-and-btn-ctn').each(function() {
            initShowMoreBtn($(this));
        });
        $('input[name="store-card"]').click(formCheckoutStoreCardChange);
    }

    checkWindow();
    writeResolution();
    
    document.addEventListener("readystatechange", function(e) {
        switch (this.readyState) {
            case "interactive": DOMReady(e); break;
            case "complete": DOMLoad(e); break;
        }
        checkWindow();
        writeResolution();
    });
    
    window.addEventListener("resize", function() {
        checkWindow();
        writeResolution();
    });
    
    window.addEventListener("popstate", function(e) {
        var ua = this.navigator.userAgent,
            isSafari = ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1,
            isPhod = ua.match(/(iPhone|iPod)/i),
            v = ua.substr(ua.indexOf("Version/") + 8, 1);

        if (!isSafari || isSafari && parseInt(v) > 5 && !isPhod) {
            this.location.reload();
        }
    });
    
})();
